function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.42121,3.07576a2.56457,2.56457,0,1,1-2.55544,2.58046A2.566,2.566,0,0,1,17.42121,3.07576Z",
  transform: "translate(-1.01377 0)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.27568,4.61391a2.307,2.307,0,1,1,2.30287-2.313A2.31231,2.31231,0,0,1,11.27568,4.61391Z",
  transform: "translate(-1.01377 0)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M3.06936,4.61162A2.04647,2.04647,0,1,1,5.11491,6.66307,2.03083,2.03083,0,0,1,3.06936,4.61162Z",
  transform: "translate(-1.01377 0)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.6001,10.518a1.79316,1.79316,0,1,1-1.78253-1.7973A1.79685,1.79685,0,0,1,4.6001,10.518Z",
  transform: "translate(-1.01377 0)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.08909,16.40865a1.53654,1.53654,0,1,1,3.073.01435,1.53654,1.53654,0,0,1-3.073-.01435Z",
  transform: "translate(-1.01377 0)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.26512,17.44411A1.27795,1.27795,0,1,1,11.27394,20a1.278,1.278,0,1,1-.00882-2.55588Z",
  transform: "translate(-1.01377 0)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M16.92989,15.38862a1.02454,1.02454,0,1,1-1.04268,1.00948A1.02891,1.02891,0,0,1,16.92989,15.38862Z",
  transform: "translate(-1.01377 0)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M19.9855,11.54674a.76873.76873,0,0,1-.76557.76071.7676.7676,0,1,1,.00043-1.53517A.76577.76577,0,0,1,19.9855,11.54674Z",
  transform: "translate(-1.01377 0)"
});

var SvgSpinner = function SvgSpinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18.97246 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spinner.f035005b.svg";
export { ForwardRef as ReactComponent };